/**
 * Extract language code from URL path
 * 
 * Utility function to extract the language code from a URL path.
 * Used in root layout where we don't have access to route params.
 * 
 * @param pathname - The URL pathname (e.g., "/en/competition/123")
 * @param defaultLang - Default language if none found (default: "en")
 * @returns The language code (e.g., "en", "fr", "it", "es", "ar")
 */
export function extractLangFromPath(pathname: string, defaultLang: string = 'en'): string {
    // Match i18nConfig.ts locales
    const locales = ['en', 'fr', 'it', 'es', 'ar']
    
    // Remove leading slash and split path
    const segments = pathname.replace(/^\//, '').split('/')
    
    // Check if first segment is a valid locale
    if (segments.length > 0 && locales.includes(segments[0])) {
        return segments[0]
    }
    
    return defaultLang
}

